<template>
	<div class="free-resource-tabs">
		<el-tabs :value="tab" type="border-card" stretch @tab-click="tabChange">
			<el-tab-pane label="教學資源" name="education">
				<div class="col" gutter="30">
					<el-pagination align-self="center" @size-change="sizeChange" @current-change="currentChange" :current-page="page" :page-size="size" layout="sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20]" :total="dataList.total" />
					<TeachSource :step="step" @stepChange="stepChange"></TeachSource>
					<el-pagination align-self="center" @size-change="sizeChange" @current-change="currentChange" :current-page="page" :page-size="size" layout="sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20]" :total="dataList.total" />
				</div>
			</el-tab-pane>
			<el-tab-pane label="本屆參與資源" name="challenge">
				<div class="col" gutter="30">
					<el-pagination align-self="center" @size-change="sizeChange" @current-change="currentChange" :current-page="page" :page-size="size" layout="sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20]" :total="dfcDataList.total" />
					<DFCSource />
					<el-pagination align-self="center" @size-change="sizeChange" @current-change="currentChange" :current-page="page" :page-size="size" layout="sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20]" :total="dfcDataList.total" />
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>

</template>

<script>
import DFCSource from "./DFCSource";
import TeachSource from "./TeachSource";
import { mapState, mapActions } from 'vuex';
const freeResource = require('@/data/free-resource.json');

export default {
	data() {
		return {
			page: 1,
			size: 5,
			tab: "",
			step: "",
		};
	},
	computed: {
		...mapState('EduResource', ['dataList']),
		...mapState('DFCResource', ['dfcDataList']),
		challengeList: () => freeResource.challenge || [],
		query() {
			return {
				page: this.page,
				size: this.size,
				tab: this.tab,
				published: true,
				step: this.step,
			}
		}
	},
	watch: {
		async $route(val) {
			if (this.tab == 'education') {
				await this.getEduResourceList(this.query);
			}
			if (this.tab == 'challenge') {
				await this.getDFCResourceList(this.query);
			}
		}
	},
	methods: {
		...mapActions('EduResource', ['getEduResourceList']),
		...mapActions('DFCResource', ['getDFCResourceList']),
		init() {
			this.page = Number(this.$route.query.page) || 1;
			this.size = Number(this.$route.query.size) || 5;
			this.tab = this.$route.query.tab || 'education';
		},
		sizeChange(size) {
			this.size = size;
			this.page = 1;
			this.$router.replace({ query: this.query });
		},
		currentChange(page) {
			this.page = page;
			this.$router.replace({ query: this.query });
		},
		tabChange(tab) {
			this.tab = tab.name;
			this.page = 1;
			this.step='認識 DFC 學習法'
			this.$router.replace({ query: this.query });
		},
		async stepChange(step){
			this.step = step;
			this.page = 1;
			this.$router.replace({ query: this.query });
		}
	},
	async created() {
		this.init();
		await this.getEduResourceList(this.query);
	},
	mounted() { },
	components: {
		DFCSource,
		TeachSource
	}
};
</script>

<style lang="scss" scoped>
.el-tabs {
	box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
}
</style>